import React from 'react';
import {useParams} from 'react-router-dom';
import {Box} from '@mui/material';
import CAMPAIGN_STATE from '@/config/campaignState';
import CampaignBriefViewer from '@/components/campaign-brief-viewer';
import useCampaignQuery from '@/hooks/queries/use-campaign-query';
import styles from './BriefViewer.module.scss';
import UnderReviewState from './UnderReviewState';

function BriefViewer() {
  const {campaignId} = useParams<{campaignId: string}>();
  const {campaign, isLoading, isError} = useCampaignQuery({campaignId});
  const isUnderReviewState = campaign?.state === CAMPAIGN_STATE.UNDER_REVIEW;
  if (isError) {
    return null;
  }

  return (
    <Box className={styles.container}>
      {isUnderReviewState ? <UnderReviewState /> : null}
      <CampaignBriefViewer campaign={campaign} isLoading={isLoading} />
    </Box>
  );
}

export default BriefViewer;
